import React, { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
    errorInfo: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, errorInfo: null };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ error, errorInfo });
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "20px", background: "#fee2e2", color: "#991b1b", borderRadius: "8px", border: "1px solid #f87171", margin: "20px", direction: "ltr" }}>
          <h2 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "10px" }}>Something went wrong.</h2>
          <details style={{ whiteSpace: "pre-wrap", fontFamily: "monospace", fontSize: "14px" }}>
            <summary>Click for error details (Please screenshot this and send it)</summary>
            <br />
            <strong>Error:</strong> {this.state.error?.toString()}
            <br /><br />
            <strong>Stack Trace:</strong>
            <br />
            {this.state.error?.stack}
            <br /><br />
            <strong>Component Stack:</strong>
            <br />
            {this.state.errorInfo?.componentStack}
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
